import React, { useCallback, useState, useMemo } from 'react';

//devExtrem
import SelectBox, { } from 'devextreme-react/select-box';

//modele
import IEditorOptions from '../models/IEditorOptions';
import ICustomSelectBoxData from '../models/ICostumSelectBoxData';

const MOIS = [
  { id: 1, description: "Janvier" },
  { id: 2, description: "Février" },
  { id: 3, description: "Mars" },
  { id: 4, description: "Avril" },
  { id: 5, description: "Mai" },
  { id: 6, description: "Juin" },
  { id: 7, description: "Juillet" },
  { id: 8, description: "Août" },
  { id: 9, description: "Septembre" },
  { id: 10, description: "Octobre" },
  { id: 11, description: "Novembre" },
  { id: 12, description: "Décembre" }
];

const useLookUpMois = () => {
  const mois: ICustomSelectBoxData[] = MOIS;

  const [currentSelectedItem, setCurrentSelectedItem] = useState<ICustomSelectBoxData>();

  const editorOptions = useMemo((): IEditorOptions<ICustomSelectBoxData[]> => {
    return {
      searchEnabled: true,
      dataSource: mois,
      displayExpr: "description",
      displayValue: "id",
      valueExpr: "id",
    }
  }, [mois])

  const MoisSelectBox = useCallback((params: any) => {
    const { dataField, component, column, data } = params
    const formOptions = component.option();
    const value = dataField ? formOptions.formData[dataField] : data[column.dataField]

    const onValueChange = (args: any) => {
      component.updateData(dataField, args.value)
    }

    const onSelectionChanged = (e: any) => {
      setCurrentSelectedItem(e.selectedItem)
    }

    return (
      <SelectBox
        value={value}
        onValueChange={onValueChange}
        readOnly={formOptions.readOnly}
        valueExpr={editorOptions.valueExpr}
        dataSource={editorOptions.dataSource}
        displayExpr={editorOptions.displayExpr}
        onSelectionChanged={onSelectionChanged}
        displayValue={editorOptions.displayValue}
      />
    )
  }, [editorOptions, currentSelectedItem])

  return {
    editorOptions,
    MoisSelectBox
  }

}

export default useLookUpMois;